import _extends from "@babel/runtime/helpers/esm/extends";
var _path;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M27.481 9.61c-.998.49-1.976.688-2.994.989-1.12-1.263-2.778-1.333-4.372-.736-1.594.597-2.638 2.056-2.615 3.73v.998c-3.239.083-6.123-1.392-7.985-3.992 0 0-4.174 7.418 3.993 10.979-1.869 1.244-3.732 2.084-5.989 1.996 3.302 1.8 6.9 2.418 10.015 1.514 3.573-1.038 6.51-3.716 7.636-7.727.337-1.22.503-2.48.496-3.746-.002-.249 1.508-2.767 1.815-4.006v.001Z",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }))
  }));
};
export default SvgTwitter;